import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {AdminService} from '../../../_services/admin.service';
import {SelectCompany} from './selectCompany';
import {SelectUser} from './selectUser';
import {SelectComponent} from 'ng2-select';
import {ACLFeature} from '../../../_models/acl-feature';
import {Permissions} from '../../../_services/permissions';
import {Router} from '@angular/router';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import * as UserActions from '../../../store/actions/user.actions';
import {UserState} from '../../../store/reducers/user.reducer';

@Component({
    selector: 'edit-impersonate',
    styleUrls: ['impersonate.less'],
    templateUrl: 'impersonate.component.html',
})
export class ImpersonateComponent implements OnInit, OnDestroy {

    companies: Array<SelectCompany> = [];
    selectedCompany: SelectCompany;

    usersLoading = false;

    users: Array<SelectUser> = [];
    selectedUser: SelectUser;
    selectedUserRoles;
    showRoles = false;

    iCanImpersonate = false;

    environment;

    @ViewChild('possibleUsersDropdown') public ngSelectForUsers: SelectComponent;

    constructor(
        private admin: AdminService,
        private permissions: Permissions,
        private router: Router,
        private store: Store<{ user: UserState }>
    ) {
      this.environment = environment;
    }

    ngOnInit() {
      this.permissions.hasFeature(ACLFeature.IMPERSONATE)
        .subscribe((success) => {
          this.iCanImpersonate = success;
        });

      this.admin.getCompanies().subscribe((companies) => {
        this.companies = companies.map((item: {id: string, name: string}) => {
          return new SelectCompany(item.id, item.name);
        });
      });
    }

    companiesOpened() {
      this.ngSelectForUsers.clickedOutside();
    }

    onCompanyChange(event) {
      this.usersLoading = true;
      this.selectedCompany = event;
      this.selectedUser = null;
      this.users = [];
      this.ngSelectForUsers.active = [];

      this.admin.getUsers(this.selectedCompany.id).subscribe((users) => {
        this.users = users.map((item: {id: string, uuid: string, username: string, roles: any}) => {
          return new SelectUser(item.id, `(UUID: ${item.uuid}) <strong>${(item.username === null ? 'No known username' : item.username)}</strong>`, `${item.roles.map(role => role.name).join(', ')}`);
        });
        this.usersLoading = false;
      });

        this.selectedUserRoles = ``;
        this.showRoles = false;
    }

    onUserChange(event) {
      this.selectedUser = event;

        for (const user of this.users) {
            if (user.id === event.id) {
                this.selectedUserRoles = user.roles;
                this.showRoles = true;
            }
        }
    }

    doImpersonate() {
      if (!this.selectedUser || this.selectedUser === null) {
        return;
      }

      this.admin.impersonate(this.selectedUser.id).subscribe((user) => {
        console.log('impersonate.user', user);
        this.store.dispatch(new UserActions.SetImpersonatedUser({userId: user.id}));

        this.router.navigate(['/']);
      });
    }

    doImpersonateInEdit2() {
      window.location.href = environment.API_ENDPOINT + '/management/impersonate/edit2/' + this.selectedUser.id;
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/management/components/impersonate/impersonate.component.ts